/**
 * Сервис для работы с разделом администратора
 */

import axios from 'axios';
import { IId } from '../models/types';

const url = '/admin';

const AdminService = {
  getCompanyConfig: () => axios.get(`/v0/config/company`),
  getTimeTableConfig: () => axios.get(`/v0/config/timetable`),
  getSecurableTypes: (id: IId) => axios.get(`/v0/accesses/permissions/actionTypes?resourceRootId=${id}`),
  getConfig: (configType: string) => axios.get(`/v0/config/${configType}`),
  saveConfig: (configType: string, data: any) =>
    axios.post(`/v0/config/${configType}`, data, {
      headers: { 'Content-Type': 'application/json' },
      transformRequest: [(data: any) => data] // Отправляем данные как есть, без сериализации
    })
};

export default AdminService;
